<section>
    <form class="row" [formGroup]="formGroup" (ngSubmit)="submit()">
        <mat-form-field class="w-4">
            <mat-label>Seleccione roles a asignar</mat-label>
            <mat-select multiple formControlName="selectedRoles">
                <mat-option *ngFor="let role of rolesAvailable" [value]="role.roleId">
                    {{ role.name}}
                </mat-option>
            </mat-select>    
        </mat-form-field>
        <button mat-raised-button color="primary">Confirmar</button>
        <button type="button" (click)="cancel()" mat-raised-button color="warn">Cancelar</button>
    </form>
</section>